import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Anomaly } from '@buda/app/types/anomaly.types';
import { UnaryFunction } from '@dice/app/types/dice.types';
import { get as _get } from 'lodash';

@Component({
  selector: 'table-column-anomaly',
  templateUrl: './table-column-anomaly.component.html',
  standalone: false,
})
export class TableColumnAnomalyComponent implements OnChanges {
  @Input() displayValue: UnaryFunction<Anomaly, string>;

  @Input() element: Anomaly;

  @Input() isSeverity: boolean;

  columnContent: string = '';

  static readonly sortEnabled = true;

  ngOnChanges(changes: SimpleChanges): void {
    const { translation, element } = changes;
    if (translation || element) {
      this.displayContent();
    }
  }

  displayContent(): void {
    if (typeof this.displayValue === 'string') {
      this.columnContent = _get(this.element, this.displayValue);
    }
    if (typeof this.displayValue === 'function') {
      this.columnContent = this.displayValue(this.element);
    }
  }

  get severityIndicatorClass(): string {
    return `severity-indicator-${this.element.severity}`;
  }
}
